<template>
  <div class="body-form">
    <Loading v-if="isLoading" />
    <Popup :message="message" v-if="isPopup" @close="() => (isPopup = false)" />
    <div style="width: 90%; margin: 30px 0;">
      <div class="menus-top">
        <span class="blue-text" @click="$router.go(-1)">Kampus Merdeka</span>
        <Arrow :width="20" :height="20" direct="left" strokeColor="#7B7E8C" class="icon" />
        <span style="color: #7b7e8c">{{ name }}</span>
      </div>
      <div class="card-form-head">
        <h1>Form {{ name }}</h1>
      </div>

      <div class="tab-selector" v-if="isEdit || isWatch">
        <button
          :class="['tab', activeTab === 'id' ? 'active-tab' : '']"
          @click="activeTab = 'id'"
        >
          Bahasa Indonesia
        </button>
        <button
          :class="['tab', activeTab === 'en' ? 'active-tab' : '']"
          @click="activeTab = 'en'"
        >
          Bahasa Inggris
        </button>
      </div>

      <div v-if="activeTab === 'id'" class="language-section">
        <div class="cart-form">
          <v-card-title class="card-form-head-2">
            <h1>Bahasa Indonesia</h1>
          </v-card-title>
          <div class="mt-5">
            <div class="content-form">
              <p>Nama</p>
              <v-text-field
                :disabled="isWatch"
                outlined
                v-model="form.name"
                :rules="[!!form.name || 'Wajib diisi!']"
                class="form-input"
                placeholder="Nama Program"
                dense
                clearable
              ></v-text-field>
            </div>
            <div class="content-form">
              <p>Tipe Program</p>
              <v-select
                :disabled="isWatch"
                class="form-input"
                :items="program_type"
                v-model="form.program_type"
                solo
                :item-text="'name'"
                :item-value="'value'"
                :item-disabled="'disabled'"
                placeholder="Pilih Tipe Program"
              ></v-select>
            </div>
            <div class="content-form">
              <p>Nama Projek</p>
              <v-text-field
                :disabled="true"
                outlined
                v-model="form.project_name"
                :rules="[!!form.project_name || 'Wajib diisi!']"
                class="form-input"
                placeholder="Nama Projek"
                dense
                clearable
              ></v-text-field>
            </div>
            <div class="content-form">
              <p>Gambar Desktop</p>
              <v-file-input
                v-model="img_web"
                accept="image/*"
                placeholder="Unggah Berkas Gambar"
                class="form-upload"
                prepend-icon=""
                outlined
                :disabled="isWatch"
              >
                <template v-slot:prepend-inner v-if="isEdit && img_web == null">
                  <ImageModal
                    :src="form.img_urls.desktop"
                    width="76.31"
                    height="37"
                    radius="3"
                  />
                </template>
                <template v-slot:append>
                  <h5 style="margin-top: 15%; color: #2d46cf">Upload</h5>
                </template>
              </v-file-input>
              <p class="note-file">*Ukuran file maks 1 MB</p>
            </div>
            <div class="content-form">
              <p>Gambar Mobile</p>
              <v-file-input
                v-model="img_web2"
                accept="image/*"
                placeholder="Unggah Berkas Gambar"
                class="form-upload"
                prepend-icon=""
                outlined
                :disabled="isWatch"
              >
                <template v-slot:prepend-inner v-if="isEdit && img_web2 == null">
                  <ImageModal
                    :src="form.img_urls.mobile"
                    width="76.31"
                    height="37"
                    radius="3"
                  />
                </template>
                <template v-slot:append>
                  <h5 style="margin-top: 15%; color: #2d46cf">Upload</h5>
                </template>
              </v-file-input>
              <p class="note-file">*Ukuran file maks 1 MB</p>
            </div>
            <div class="content-form">
              <p>Ringkasan</p>
              <v-textarea
                :disabled="isWatch"
                outlined
                v-model="form.summary"
                :rules="[!!form.summary || 'Wajib diisi!']"
                class="form-input"
                placeholder="Ringkasan Kegiatan"
                dense
                clearable
                :rows="2"
              ></v-textarea>
            </div>
            <div class="content-form">
              <p>Kuota</p>
              <v-text-field
                :disabled="isWatch"
                outlined
                v-model="form.quota"
                :rules="[!!form.quota || 'Wajib diisi!']"
                type="number"
                class="form-input"
                placeholder="10"
                dense
                clearable
              ></v-text-field>
            </div>
            <div class="content-form">
              <p>SKS</p>
              <v-text-field
                :disabled="isWatch"
                outlined
                v-model="form.sks"
                :rules="[!!form.sks || 'Wajib diisi!']"
                type="number"
                class="form-input"
                placeholder="20"
                dense
                clearable
              ></v-text-field>
            </div>
            <div class="content-form">
              <p>Deskripsi</p>
              <v-textarea
                :disabled="isWatch"
                outlined
                v-model="form.description"
                :rules="[!!form.description || 'Wajib diisi!']"
                class="form-input"
                placeholder="Deskripsi Kegiatan"
                dense
                clearable
                :rows="5"
              ></v-textarea>
            </div>
            <div class="content-form">
              <p>Tipe Aktivitas</p>
              <v-select
                :disabled="isWatch"
                class="form-input"
                :items="activity_type"
                v-model="form.activity_type"
                solo
                :item-text="'name'"
                :item-value="'value'"
                placeholder="Pilih Tipe Aktivitas"
              ></v-select>
            </div>
            <div class="content-form">
              <p>Cakupan Proyek</p>
              <div class="location-row" v-for="(data, idx) in form.project_scopes" :key="idx">
                <v-text-field
                  :disabled="isWatch"
                  outlined
                  v-model="form.project_scopes[idx]"
                  class="form-input no-space"
                  dense
                  placeholder="Cakupan Proyek"
                ></v-text-field>
              </div>
              <div class="criteria-btn">
                <Button
                  name="-"
                  width="40px"
                  height="35px"
                  title="Remove Scope"
                  @click="() => form.project_scopes.splice(form.project_scopes.length - 1, 1)"
                  outline
                  v-if="form.project_scopes.length > 1 && !isWatch"
                />
                <Button
                  name="+"
                  width="40px"
                  height="35px"
                  title="Add Scope"
                  v-if="!isWatch"
                  @click="() => form.project_scopes.push('')"
                />
              </div>
            </div>
            <div class="content-form">
              <p>Kriteria</p>
              <vue-editor
                :disabled="isWatch"
                v-model="form.requirements"
                :editorToolbar="$helpers.customToolBar()"
                class="form-input"
              ></vue-editor>
            </div>
            <div class="content-form">
              <p>Link Registrasi</p>
              <v-text-field
                :disabled="isWatch"
                outlined
                v-model="form.registration_link"
                :rules="[!!form.registration_link || 'Wajib diisi!']"
                class="form-input"
                placeholder="Link registrasi"
                dense
                clearable
              ></v-text-field>
            </div>
            <div class="content-form">
              <p>Tanggal Berlangsung</p>
              <v-row no-gutters class="pt-2">
                <v-col cols="6">
                  <v-row no-gutters>
                    <v-col cols="5" class="pt-2"> Mulai </v-col>
                    <v-col cols="6">
                      <v-text-field
                        :disabled="isWatch"
                        outlined
                        type="date"
                        :rules="[!!form.start_date || 'Wajib diisi!']"
                        v-model="form.start_date"
                        class="form-input"
                        placeholder="00:00"
                        dense
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="6">
                  <v-row no-gutters>
                    <v-col cols="6" class="pt-2"> Selesai </v-col>
                    <v-col cols="6">
                      <v-text-field
                        :disabled="isWatch"
                        outlined
                        type="date"
                        :rules="[!!form.end_date || 'Wajib diisi!']"
                        v-model="form.end_date"
                        class="form-input"
                        placeholder="00:00"
                        dense
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </div>
            <div class="content-form" v-if="form.activity_type != 'REMOTE'">
              <p>Lokasi</p>
              <div class="location-row" v-for="(data, idx) in form.locations" :key="idx">
                <span>Lokasi {{ idx + 1 }}</span>
                <v-text-field
                  disabled
                  outlined
                  v-model="form.locations[idx].name"
                  class="form-input no-space"
                  dense
                  placeholder="Nama Lokasi"
                ></v-text-field>
                <v-text-field
                  disabled
                  outlined
                  v-model="form.locations[idx].address"
                  class="form-input no-space"
                  placeholder="Alamat Lokasi"
                  dense
                ></v-text-field>
                <v-text-field
                  disabled
                  outlined
                  v-model="form.locations[idx].url"
                  class="form-input no-space"
                  placeholder="URL Google Maps"
                  dense
                ></v-text-field>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div v-if="activeTab === 'en'" class="language-section">
        <div class="cart-form">
          <v-card-title class="card-form-head-2">
            <h1>Bahasa Inggris</h1>
          </v-card-title>
          <div class="mt-5">
            <div class="content-form">
              <p>Name</p>
              <v-text-field
                :disabled="isWatch"
                outlined
                v-model="formEng.name"
                class="form-input"
                placeholder="Enter Program Name"
                dense
                clearable
              ></v-text-field>
            </div>
            <div class="content-form">
              <p>Project Name</p>
              <v-text-field
                :disabled="true"
                outlined
                v-model="formEng.project_name"
                class="form-input"
                placeholder="Enter Project Name"
                dense
                clearable
              ></v-text-field>
            </div>
            <div class="content-form">
              <p>Summary</p>
              <v-textarea
                :disabled="isWatch"
                outlined
                v-model="formEng.summary"
                class="form-input"
                placeholder="Enter Activity Summary"
                dense
                clearable
                :rows="2"
              ></v-textarea>
            </div>
            <div class="content-form">
              <p>Description</p>
              <v-textarea
                :disabled="isWatch"
                outlined
                v-model="formEng.description"
                class="form-input"
                placeholder="Enter Activity Description"
                dense
                clearable
                :rows="5"
              ></v-textarea>
            </div>
            <div class="content-form">
              <p>Project Scopes</p>
              <div class="location-row" v-for="(data, idx) in formEng.project_scopes" :key="idx">
                <v-text-field
                  :disabled="isWatch"
                  outlined
                  v-model="formEng.project_scopes[idx]"
                  class="form-input no-space"
                  dense
                  placeholder="Enter Project Scope"
                ></v-text-field>
              </div>
              <div class="criteria-btn">
                <Button
                  name="-"
                  width="40px"
                  height="35px"
                  title="Remove Scope"
                  @click="() => formEng.project_scopes.splice(formEng.project_scopes.length - 1, 1)"
                  outline
                  v-if="formEng.project_scopes.length > 1 && !isWatch"
                />
                <Button
                  name="+"
                  width="40px"
                  height="35px"
                  title="Add Scope"
                  v-if="!isWatch"
                  @click="() => formEng.project_scopes.push('')"
                />
              </div>
            </div>
            <div class="content-form">
              <p>Requirements</p>
              <vue-editor
                :disabled="isWatch"
                v-model="formEng.requirements"
                :editorToolbar="$helpers.customToolBar()"
                class="form-input"
              ></vue-editor>
            </div>
          </div>
        </div>
      </div>

      <div class="submit-box" v-if="!isWatch">
        <Button
          name="Batalkan"
          outline
          class="me-3"
          @click="$router.push('/kampus-merdeka')"
        />
        <Button
          :name="isEdit ? 'Simpan' : 'Simpan & Publish'"
          :width="isEdit ? '156px' : '200px'"
          @click="onSubmit"
          :disabled="!validData"
          style="background-color: #2d46cf; color: #ffffff"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { VueEditor } from 'vue2-editor';
import Loading from '@/components/ilustration/Loading.vue';
import Button from '@/components/Button.vue';
import Popup from '@/components/others/Popup.vue';
import ImageModal from '@/components/ImageModal.vue';
import Arrow from '@/components/icons/Arrow.vue';

export default {
  name: 'FormKampusMerdeka',
  components: {
    VueEditor,
    Loading,
    Button,
    Popup,
    ImageModal,
    Arrow,
  },
  computed: {
    validData() {
      const regexURL = /^(ftp|http|https):\/\/[^ "]+$/;
      if (this.form.activity_type !== 'REMOTE') {
        for (let i = 0; i < this.form.locations.length; i++) {
          if (!regexURL.test(this.form.locations[i].url)) return false;
        }
      }
      return (
        this.form.name &&
        this.form.program_type &&
        this.form.project_name &&
        this.form.summary &&
        this.form.quota &&
        this.form.start_date &&
        this.form.end_date &&
        this.form.sks &&
        this.form.description &&
        this.form.project_scopes[0] &&
        this.form.requirements &&
        this.form.registration_link &&
        this.form.activity_type
      );
    },
  },
  data() {
    return {
      id: null,
      name: '',
      isLoading: false,
      isWatch: false,
      isEdit: false,
      message: '',
      isPopup: false,
      activeTab: 'id',
      img_web: null,
      img_web2: null,
      program_type: [
        { name: 'Magang Bersertifikat', value: 'MB' },
        { name: 'Studi Independent Bersertifikat', value: 'SIB', disabled: true },
      ],
      activity_type: [
        { name: 'Hybrid', value: 'HYBRID' },
        { name: 'On Site', value: 'ONSITE' },
        { name: 'Remote', value: 'REMOTE' },
      ],
      location_obj: {
        name: '',
        address: '',
        url: '',
      },
      form: {
        name: '',
        program_type: 'MB',
        project_name: 'Digital Acceleration Project',
        img_urls: { mobile: '', desktop: '' },
        summary: '',
        quota: 0,
        sks: 20,
        description: '',
        activity_type: 'HYBRID',
        project_scopes: [''],
        requirements: '',
        registration_link: '',
        start_date: '',
        end_date: '',
        locations: [
          {
            name: 'Gedung Ariobimo Sentral',
            address: 'Jl. H. R. Rasuna Said No.Kav. X-2 No. 5, RT.9/RW.4, Kuningan Tim., Kecamatan Setiabudi, Kota Jakarta Selatan, Daerah Khusus Ibukota Jakarta 12950',
            url: 'https://www.google.com/maps/place/Ariobimo+Sentral,+Jl.+H.+R.+Rasuna+Said+No.Kav.+X-2+No.+5,+RT.9%2FRW.4,+Kuningan+Tim.,+Kecamatan+Setiabudi,+Kota+Jakarta+Selatan,+Daerah+Khusus+Ibukota+Jakarta+12950/@-6.2272516,106.8308258,17z/data=!3m1!4b1!4m6!3m5!1s0x2e69f3ee271a2a91:0x1a27577809196067!8m2!3d-6.2272569!4d106.8334007!16s%2Fg%2F11cjj3h6rn?entry=ttu',
          },
        ],
      },
      formEng: {
        name: '',
        project_name: 'Digital Acceleration Project',
        summary: '',
        description: '',
        project_scopes: [''],
        requirements: '',
      },
    };
  },
  methods: {
    checkingType() {
      this.name = this.$route.meta.name;
      this.isWatch = this.$route.path.lastIndexOf('watch') >= 0;
      this.isEdit = this.$route.path.lastIndexOf('edit') >= 0;
      this.id = this.$route.params.id;
      if (!this.id) return;
      this.getDataKampusMerdeka();
    },
    tidyUpDataFromGet(data) {
      const start_date = String(data.start_date).split('T')[0];
      const end_date = String(data.end_date).split('T')[0];
      return {
        ...data,
        start_date,
        end_date,
      };
    },
    async getDataKampusMerdeka() {
      this.isLoading = true;
      try {
        const resp = await this.$crm_http.get('/v1/kampus-merdeka/' + this.id);
        const { kampus_merdeka } = resp.data.data;
        this.form = this.tidyUpDataFromGet(kampus_merdeka);
        this.form.locations = [
          {
            name: 'Gedung Ariobimo Sentral',
            address: 'Jl. H. R. Rasuna Said No.Kav. X-2 No. 5, RT.9/RW.4, Kuningan Tim., Kecamatan Setiabudi, Kota Jakarta Selatan, Daerah Khusus Ibukota Jakarta 12950',
            url: 'https://www.google.com/maps/place/Ariobimo+Sentral,+Jl.+H.+R.+Rasuna+Said+No.Kav.+X-2+No.+5,+RT.9%2FRW.4,+Kuningan+Tim.,+Kecamatan+Setiabudi,+Kota+Jakarta+Selatan,+Daerah+Khusus+Ibukota+Jakarta+12950/@-6.2272516,106.8308258,17z/data=!3m1!4b1!4m6!3m5!1s0x2e69f3ee271a2a91:0x1a27577809196067!8m2!3d-6.2272569!4d106.8334007!16s%2Fg%2F11cjj3h6rn?entry=ttu',
          },
        ];
        await this.getBilingual();
      } catch (err) {
        this.message = err.response?.data?.data || 'Failed to load data.';
        this.isPopup = true;
      } finally {
        this.isLoading = false;
      }
    },
    async getBilingual() {
      try {
        const { data } = await this.$crm_http.get(
          `/v1/bilingual/record/${this.id}?table_name=kampus_merdeka&language_code=en`
        );
        const resp = JSON.parse(data.data.bilingual?.translated_data || '{}');
        this.formEng = {
          name: resp.name || '',
          project_name: resp.project_name || 'Digital Acceleration Project',
          summary: resp.summary || '',
          description: resp.description || '',
          project_scopes: resp.project_scopes || [''],
          requirements: resp.requirements || '',
        };
      } catch (err) {
        console.log(err);
      }
    },
    async onSubmit() {
      this.isLoading = true;
      try {
        let img_urls = { ...this.form.img_urls };

        if (this.img_web) {
          const imageForm = new FormData();
          imageForm.append('attachment', this.img_web);
          const webRes = await this.$crm_http.post('/v1/upload-file', imageForm);
          img_urls.desktop = webRes.data.data.upload_image_response.url_w_query;
          imageForm.delete('attachment');
        }
        if (this.img_web2) {
          const imageForm = new FormData();
          imageForm.append('attachment', this.img_web2);
          const webRes = await this.$crm_http.post('/v1/upload-file', imageForm);
          img_urls.mobile = webRes.data.data.upload_image_response.url_w_query;
          imageForm.delete('attachment');
        }

        const payload = {
          name: this.form.name,
          program_type: this.form.program_type,
          project_name: this.form.project_name,
          img_urls: img_urls,
          summary: this.form.summary,
          quota: parseInt(this.form.quota),
          sks: parseInt(this.form.sks),
          description: this.form.description,
          activity_type: this.form.activity_type,
          project_scopes: this.form.project_scopes,
          requirements: this.form.requirements,
          registration_link: this.form.registration_link,
          start_date: this.form.start_date,
          end_date: this.form.end_date,
          locations: this.form.activity_type !== 'REMOTE' ? this.form.locations : [],
        };

        if (this.isEdit) {
          await this.$crm_http.put('/v1/kampus-merdeka/' + this.form.id, payload);
          await this.onSubmitBilingual(img_urls);
        } else {
          await this.$crm_http.post('/v1/kampus-merdeka', payload);
        }

        setTimeout(() => {
          this.$router.push('/kampus-merdeka');
        }, 2000);
      } catch (err) {
        this.message = err.response?.data?.data || 'Failed to submit data.';
        this.isPopup = true;
        this.isLoading = false;
      }
    },
    async onSubmitBilingual(img_urls) {
      const payload = {
        table_name: 'kampus_merdeka',
        record_id: this.id,
        language_code: 'en',
        translated_data: JSON.stringify({
          name: this.formEng.name,
          project_name: this.formEng.project_name,
          summary: this.formEng.summary,
          description: this.formEng.description,
          project_scopes: this.formEng.project_scopes,
          requirements: this.formEng.requirements,
          program_type: this.form.program_type,
          img_urls: img_urls,
          quota: parseInt(this.form.quota),
          sks: parseInt(this.form.sks),
          activity_type: this.form.activity_type,
          registration_link: this.form.registration_link,
          start_date: this.form.start_date,
          end_date: this.form.end_date,
        }),
      };
      try {
        await this.$crm_http.post('/v1/bilingual', payload);
      } catch (err) {
        console.log(err);
      }
    },
  },
  mounted() {
    this.checkingType();
  },
};
</script>

<style scoped>
.menus-top {
  padding-top: 10px;
  display: flex;
  font-size: 16px;
  gap: 8px;
  align-items: center;
  margin-bottom: 10px;
}
.card-form-head {
  display: flex;
  margin: 40px 0;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 20px;
}
.card-form-head-2 {
  display: flex;
  margin-left: -35px;
  margin-right: -20px;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 20px;
  border-bottom: 1px solid gray;
}
.card-form-head-2 h1 {
  font-weight: 700;
  font-size: 18px;
  color: #36373f;
  font-family: 'Poppins', sans-serif;
  margin: 0;
}
.tab-selector {
  display: flex;
  justify-content: center;
  gap: 10px;
  margin-bottom: 50px;
}
.tab {
  padding: 10px 20px;
  border: 1px solid #ccc;
  border-radius: 8px;
  cursor: pointer;
  background-color: #f9f9f9;
}
.active-tab {
  background-color: #2d46cf;
  color: white;
  border-color: #2d46cf;
}
.body-form {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #fafaf9;
  padding-bottom: 30px;
  min-height: 100vh;
}
.cart-form {
  position: relative;
  margin: 40px 0;
  border-radius: 30px;
  padding: 30px 40px;
  background-color: #ffffff;
  box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 12px;
}
.language-section {
  margin-bottom: 30px;
}
.content-form {
  margin-top: 15px;
}
.content-form p {
  font-size: 14px;
  margin: 3px 0;
  font-weight: bold;
}
.form-input {
  border-radius: 14px !important;
  background-color: transparent !important;
}
.form-input:focus {
  border-color: #2d46cf;
  box-shadow: 0 0 5px rgba(45, 70, 207, 0.3);
}
.form-upload .v-input__slot {
  height: 62px !important;
  background-color: #ffffff !important;
}
.form-upload .v-text-field__details {
  display: none;
}
.submit-box {
  display: flex;
  justify-content: center;
  margin: 20px 0;
}
.note-file {
  font-weight: 400;
  font-size: 12px;
  color: #b80f0a;
  margin-bottom: 20px !important;
}
.location-row {
  display: flex;
  flex-direction: column;
  gap: 10px;
  flex-wrap: wrap;
  margin: 10px 0;
}
.criteria-btn {
  display: flex;
  flex-direction: row;
  gap: 10px;
  flex-wrap: wrap;
  margin: 10px 0;
  justify-content: flex-end;
}
.no-space {
  margin-bottom: -20px;
}
.blue-text {
  font-weight: bold;
  color: #162ca2;
  cursor: pointer;
}
</style>